import { createApp } from 'vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import router from './router'
import App from './App.vue'
import { generateApi, apiKey } from './libs/api'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

dayjs.extend(isToday)

const app = createApp(App)
if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://50d901fe39044288942ef85349c37d97@o569163.ingest.sentry.io/4504073128509440',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['drawtalk.laineus.com', /^\//],
      })
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: ['Network Error', 'Unable to preload', 'Request failed', 'Importing a module', 'Failed to fetch dynamically imported module']
  })
}

const getFingerprint = () => {
  return FingerprintJS.load().then(fs => fs.get().then(result => result.visitorId))
}

getFingerprint().then(fingerprint => {
  const api = generateApi(fingerprint)
  app.config.globalProperties.window = window
  app.use(router)
  app.provide(apiKey, api)
  app.mount('#app')
})

window.addEventListener('load', () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/serviceWorker.js')
  }
})
